import { RouteConfig } from 'vue-router';

const analyze: RouteConfig = {
  path: '/analyze',
  component: () => import('../views/analyze/analyze.vue'),
  meta: {
    title: '数据开发中心'
  },
  children: [
    {
      path: '/analyze/dashboard',
      meta: {
        title: '客户旅程分析仪表盘'
      },
      component: () => import('../views/analyze/pages/dashboard/dashboard.vue')
    },
    {
      path: '/analyze/custom',
      meta: {
        title: '自助指标分析'
      },
      component: () => import('../views/analyze/pages/custom/custom.vue'),
      redirect: '/analyze/custom/main',
      children: [
        {
          path: '/analyze/custom/main',
          meta: {
            title: '分析清单'
          },
          component: () => import('../views/analyze/pages/custom/custom-main.vue')
        },
        {
          path: '/analyze/custom/detail',
          meta: {
            title: '仪表详情'
          },
          component: () => import('../views/analyze/pages/custom/custom-detail.vue')
        },
        {
          path: '/analyze/custom/add',
          meta: {
            title: '创建自助指标分析'
          },
          component: () => import('../views/analyze/pages/custom/add-custom.vue')
        },
        {
          path: '/analyze/custom/edit',
          meta: {
            title: '编辑自助指标分析'
          },
          component: () => import('../views/analyze/pages/custom/add-custom.vue')
        }
      ]
    },
    {
      path: '/analyze/scene_pm',
      meta: {
        title: '产品管理'
      },
      component: () => import('../views/analyze/pages/dashboard/scene_1.vue')
    },
    {
      path: '/analyze/scene_ca',
      meta: {
        title: '客户获取'
      },
      component: () => import('../views/analyze/pages/dashboard/scene_2.vue')
    },
    {
      path: '/analyze/scene_ci',
      meta: {
        title: '客户申请发卡'
      },
      component: () => import('../views/analyze/pages/dashboard/scene_3.vue')
    },
    {
      path: '/analyze/scene_co',
      meta: {
        title: '客户经营'
      },
      component: () => import('../views/analyze/pages/dashboard/scene_4.vue')
    },
    {
      path: '/analyze/scene_cs',
      meta: {
        title: '客户服务'
      },
      component: () => import('../views/analyze/pages/dashboard/scene_5.vue')
    },
    {
      path: '/analyze/scene_tp',
      meta: {
        title: '交易处理'
      },
      component: () => import('../views/analyze/pages/dashboard/scene_6.vue')
    },
    {
      path: '/analyze/scene_bp',
      meta: {
        title: '账单还款'
      },
      component: () => import('../views/analyze/pages/dashboard/scene_7.vue')
    },
    {
      path: '/analyze/scene_dr',
      meta: {
        title: '债务回收'
      },
      component: () => import('../views/analyze/pages/dashboard/scene_8.vue')
    },
    {
      path: '/analyze/unit_dashboard',
      meta: {
        title: '板块部门运营仪表盘'
      },
      component: () => import('../views/analyze/pages/dashboard/unit_dashboard.vue')
    },
    {
      path: '/analyze/unit_channel',
      meta: {
        title: '渠道板块'
      },
      component: () => import('../views/analyze/pages/dashboard/unit_1.vue')
    },
    {
      path: '/analyze/unit_market',
      meta: {
        title: '市场板块'
      },
      component: () => import('../views/analyze/pages/dashboard/unit_2.vue')
    },
    {
      path: '/analyze/unit_risk',
      meta: {
        title: '风险板块'
      },
      component: () => import('../views/analyze/pages/dashboard/unit_3.vue')
    },
    {
      path: '/analyze/unit_operation',
      meta: {
        title: '运营板块'
      },
      component: () => import('../views/analyze/pages/dashboard/unit_4.vue')
    }
  ]
};

export default analyze;
